import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { TaktIdProvider, createStormTaktId } from '@amzn/storm-ui';
import { F as FormLayoutContent } from './FormLayoutContent-Dj1L2Ajy.js';
import { F as FormLayoutFooter } from './FormLayoutFooter-DdsU8_Q_.js';
import { F as FormLayoutHeader } from './FormLayoutHeader-CgQx9ByR.js';
import { F as FormLayoutWrapper } from './FormLayoutWrapper-BLcX_Mmv.js';
import { F as FormStageProvider } from './contexts/FormStage/FormStageProvider-CItwRlDn.js';

const FormLayout = ({
  anchorElement,
  cancelButtonLabel,
  children,
  closeButtonLabel,
  disableSubmitButtonTooltip,
  formContext,
  formId,
  isIntroSkipped = false,
  isMobile,
  type,
  isOpen,
  isSubmitSuccessful = false,
  isSubmitting,
  mobileCloseButtonLabel,
  mobileShareButtonLabel,
  onClickResubmit,
  onClose,
  popperOffset,
  popperPlacement,
  popperPortalElementId,
  popperStrategy,
  popperStyle,
  renderDisclaimer,
  renderHeader,
  renderIntro,
  renderPrompt,
  renderSuccess,
  renderError,
  resubmitButtonLabel,
  resubmitEnabled,
  submitButtonLabel,
  submitEnabled,
  submitErrorMessage,
  submittingButtonLabel,
  taktId,
  taktValue,
  validationErrorMessage,
  withoutConfirmation,
  hideActions,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('form-layout')
}, /*#__PURE__*/React__default.createElement(FormStageProvider, {
  isIntroSkipped: isIntroSkipped,
  isMobile: isMobile,
  isSubmitSuccessful: isSubmitSuccessful,
  withoutConfirmation: withoutConfirmation
}, /*#__PURE__*/React__default.createElement(FormLayoutWrapper, _extends({}, restProps, {
  anchorElement: anchorElement,
  isMobile: isMobile,
  type: type,
  isOpen: isOpen,
  mobileCloseButtonLabel: mobileCloseButtonLabel,
  mobileShareButtonLabel: mobileShareButtonLabel,
  onClose: onClose,
  popperOffset: popperOffset,
  popperPlacement: popperPlacement,
  popperPortalElementId: popperPortalElementId,
  popperStrategy: popperStrategy,
  popperStyle: popperStyle,
  renderMobileIntroHeader: renderHeader,
  renderIntro: renderIntro
}), type !== 'inline' && /*#__PURE__*/React__default.createElement(FormLayoutHeader, {
  closeButtonLabel: closeButtonLabel,
  isMobile: isMobile,
  onClose: onClose,
  renderHeader: renderHeader
}), /*#__PURE__*/React__default.createElement(FormLayoutContent, {
  formContext: formContext,
  hideActions: hideActions,
  isMobile: isMobile,
  renderDisclaimer: renderDisclaimer,
  renderPrompt: renderPrompt,
  renderSuccess: renderSuccess,
  resubmitEnabled: resubmitEnabled
}, children), !hideActions && /*#__PURE__*/React__default.createElement(FormLayoutFooter, {
  cancelButtonLabel: cancelButtonLabel,
  disableSubmitButtonTooltip: disableSubmitButtonTooltip,
  formId: formId,
  isMobile: isMobile,
  isSubmitting: isSubmitting,
  onClickResubmit: onClickResubmit,
  onClose: onClose,
  renderError: renderError,
  resubmitButtonLabel: resubmitButtonLabel,
  resubmitEnabled: resubmitEnabled,
  submitButtonLabel: submitButtonLabel,
  submitEnabled: submitEnabled,
  submitErrorMessage: submitErrorMessage,
  submittingButtonLabel: submittingButtonLabel,
  validationErrorMessage: validationErrorMessage
}))));

export { FormLayout as F };
//# sourceMappingURL=FormLayout-D2qp9e0y.js.map
